// Copyright (c) Docugami, Inc. All rights reserved.

import { CanvasHelperStatics } from "components/doc_hosting/doc_hosts/web/CanvasHelperStatics";
import { ComponentId } from "sdv/engine/Component";
import { IDrawCommand, IRenderer, IRendererInput, Queries } from "sdv/engine/Engine";
import { Box } from "store/shared_types";
import { chunkHighlightUnconfirmedColor, chunkSelectedColor } from "components/shell/presentation/AppStyles";
import { SearchStateComponent } from "sdv/components/SearchStateComponent";

/**
 * Renders search results to the canvas.
 */
export class SearchRenderer implements IRenderer {
    get renderEnabled(): boolean { return true; }

    queries: Queries = {
        searchState: { types: [ComponentId.SearchState] }
    }

    render(engine: IRendererInput): IDrawCommand[] {
        const commands: IDrawCommand[] = []

        const searchEntity = this.queries.searchState.query!.single();
        const searchComp = searchEntity?.getComponent<SearchStateComponent>(ComponentId.SearchState)!;
        if (!!searchComp?.render) {
            const items = Object.values(searchComp.renderResults);
            const selected = searchComp.renderResults[searchComp.selectedKey ?? ''];
            for (let i = 0; i < items.length; ++i) {
                const item = items[i];
                const isSelected = item === selected;
                commands.push(context => drawSearchResult(context, item, isSelected ? chunkSelectedColor : chunkHighlightUnconfirmedColor));
            }
        }

        return commands;
    }
}

function drawSearchResult(context: CanvasRenderingContext2D, boxes: Box[], color: string): void {
    context.globalAlpha = .55;
    for (const box of boxes) {
        CanvasHelperStatics.fillRectangle(
            context,
            box,
            color,
            true);
    }
}
